import { render, staticRenderFns } from "./slider-trash-icon.vue?vue&type=template&id=00256a44&scoped=true"
import script from "./slider-trash-icon.vue?vue&type=script&lang=js"
export * from "./slider-trash-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00256a44",
  null
  
)

export default component.exports